import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {AvtaleRessurs} from "felles/tjenester/ressurser/AvtaleRessurs";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Dialog} from "../../../../tjenester/Dialog";

const css = require('./redigerAvtale.scss');

export class RedigerAvtaleKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleRediger', {
                bindings: {avtale: '<', vedLagret: '&', vedAvbryt: '&'},
                controller: RedigerAvtaleKontroller.forInjisering(),
                template: require('./redigerAvtale.html')
            });
    }

    static forInjisering() {
        return [
            AvtaleRessurs.regNavn,
            WebNavigasjon.regNavn,
            Dialog.regNavn,
            regNavn.gettext.gettextCatalog,

            Kontekst.regNavn,
            RedigerAvtaleKontroller
        ]
    }

    constructor(private avtaleRes: AvtaleRessurs,
                private webNavigasjon: WebNavigasjon,
                private dialog: Dialog,
                private gettextCatalog: gettextCatalog,
                private kontekst: Kontekst) {
    }

    avtale: l.AvtaledetaljerModell; //settes via bindings/$onChanges
    vedLagret: (arg: { avtale: l.AvtaledetaljerModell; kontaktpersonEndret: boolean; }) => void; //satt via bindings
    vedAvbryt: () => void; //satt via bindings

    lagrer = false;
    modell: RedigerAvtaleModell;

    lagre() {
        if (this.avtale.kontaktperson.id !== this.modell.valgtKontaktperson.id) {
            ///dialoginnhold for dialog ved endring av kontaktperson for avtale
            const dialogInnhold = this.gettextCatalog.getString('Du er i ferd med å fjerne deg selv som kontaktperson for denne organisasjonen. Dette medfører at du ikke lenger har tilgang til å redigere avtaleinformasjon!');

            this.dialog.confirm(
                ///dialogtittel for dialog ved endring av avtalens kontaktperson
                this.gettextCatalog.getString('Endring av kontaktperson'),
                `<p class="e2e-endre-kontaktperson-advarsel">${dialogInnhold}</p>`,
                ///ok-knapp i dialog ved endring av avtalens kontaktperson
                this.gettextCatalog.getString('Fortsett'),
                ///avbryt-knapp i dialog ved endring av avtalens kontaktperson
                this.gettextCatalog.getString('Avbryt'))
                .then(() => this.lagreEndringer(true));
            return;
        }

        this.lagreEndringer(false);
    }

    private lagreEndringer(kontaktpersonEndret: boolean) {
        this.avtaleRes.oppdater(this.modell.somSpesifikasjon()).$promise
            .then(avtale => {
                //siden vi potensielt har endret avtale.kontaktperson og dette påvirker
                //kontekst.avtalerBrukerErKontaktpersonFor() sørger vi her for å relaste kontekst
                this.kontekst.relastBrukerOgGrupper();
                this.vedLagret({avtale: avtale, kontaktpersonEndret: kontaktpersonEndret});
            });
    }

    avbryt() {
        this.vedAvbryt();
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changesInneholder(changes, 'avtale'))
            this.initModell()
    }

    //private hjelpemetoder

    private initModell() {
        this.modell = new RedigerAvtaleModell(this.avtale);
    }
}

export class RedigerAvtaleModell {
    tilgjengeligeKontaktpersoner: l.EnkelBrukerModell[];
    valgtKontaktperson: l.EnkelBrukerModell;

    spesifikasjon: l.RedigerAvtalepesifikasjon;

    constructor(avtale: l.AvtaledetaljerModell) {
        //det er ikke gitt at avtale.kontaktperson er blandt avtale.aktiveBrukere, legger derfor denne eksplisitt til
        this.tilgjengeligeKontaktpersoner = _([avtale.kontaktperson]).unionBy(avtale.aktiveBrukere, b => b.id).value();
        this.valgtKontaktperson = avtale.kontaktperson;

        this.spesifikasjon = {
            id: avtale.id,
            navn: avtale.navn,
            kontaktperson: avtale.kontaktperson.id
        };
    }

    somSpesifikasjon(): l.RedigerAvtalepesifikasjon {
        this.spesifikasjon.kontaktperson = this.valgtKontaktperson.id;
        return this.spesifikasjon;
    }
}

